<!-- 诉求管理 -->
<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          v-model="queryData.key"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <el-button
          size="small"
          type="success"
          class="ml10"
          @click="onOpenAddDic({})"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column
          prop="Name"
          label="诉求人"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="Tel"
          label="联系电话"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="State"
          label="状态"
          show-overflow-tooltip
          width="100"
        >
          <template #default="scope">
            <el-tag :type="scope.row.State_type" size="small">{{
              scope.row.State_show
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="诉求类型"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="Content"
          label="诉求内容"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Result"
          label="处理结果"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="Result" label="附件图片" show-overflow-tooltip>
          <template #default="scope">
            <el-image
              v-if="scope.row.Imgurls"
              :src="scope.row.Imgurls"
              style="width: 170px; height: 100px"
            ></el-image>
            <span v-else>未上传</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="text"
              @click="gotoPreView(scope.row)"
              >处理</el-button
            >
            <el-button
              size="small"
              text
              type="text"
              @click="onRowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <dicDialog
      ref="dicDialogRef"
      :Type="curRow.Type"
      :DeclareResult="DeclareResult"
      @refresh="queryTableData()"
    ></dicDialog>
  </div>
</template>

<script>
import {
  getDemandList,
  deleteDemandDetail,
} from "@/api/appealManage/appealManage";
import dicDialog from "./dialog.vue";
export default {
  name: "appealManagement",
  components: { dicDialog },
  data() {
    return {
      curRow: {},
      loading: false,
      DeclareResult: "",
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        key: "",
      },
    };
  },
  methods: {
    onRowDel(row) {
      let that = this;
      this.$confirm("是否删除该数据？", "提示", {}).then(() => {
        that.HttpDeleteApprovle({ id: row.Id });
      });
    },
    onOpenAddDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "add");
    },
    onOpenEditDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "preview");
    },
    gotoPreView(row) {
      this.curRow = row;
      this.DeclareResult = row.DeclareResult;
      this.$refs.dicDialogRef.openDialog(row, "preview");
    },
    queryTableData() {
      let param = {
        page: this.queryData.page,
        intPageSize: this.queryData.pageSize,
        key: this.queryData.key,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询字典类型列表
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await getDemandList(param);
      this.loading = false;

      if (res.data.status == 200) {
        let raw = res.data.response;
        this.total = raw.dataCount;
        let list = raw.data || [];
        let dic = {
          0: {
            type: "primary",
            txt: "处理中",
          },
          1: {
            type: "success",
            txt: "已处理",
          },
        };
        list.forEach((o) => {
          o.State_show = dic[o.State].txt;
          o.State_type = dic[o.State].type;
        });
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async HttpDeleteApprovle(param) {
      const response = await deleteDemandDetail(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },

  mounted() {
    this.queryTableData();
  },
};
</script>

<style scoped></style>
